import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE } from "../api/api";

// Глобально: все axios-запросы шлют cookie
axios.defaults.withCredentials = true;

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // При загрузке — проверяем сессию через cookie
  useEffect(() => {
    const verifySession = async () => {
      try {
        const response = await axios.get(`${API_BASE}/auth/me`);
        setUser(response.data);
      } catch (err) {
        // 401 — значит не залогинен, это нормально
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    verifySession();
  }, []);

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${API_BASE}/auth/login`, {
        email,
        password
      });

      // Бэк ставит cookie, в ответе только user
      setUser(response.data.user);

      return { success: true };

    } catch (err) {
      return {
        success: false,
        error: err.response?.data?.error || 'Ошибка при входе'
      };
    }
  };

  const register = async (email, password, name, consents) => {
    try {
      const response = await axios.post(`${API_BASE}/auth/register`, {
        email, password, name, consents,
      });
      return {
        success: true,
        needsVerification: response.data.needsVerification || true,
      };
    } catch (err) {
      const status = err.response?.status;
      const data = err.response?.data;

      if (status === 409) {
        return {
          success: false,
          error: 'Этот email уже зарегистрирован. Войдите или используйте другой.',
          code: 'EMAIL_ALREADY_EXISTS',
        };
      }

      return {
        success: false,
        error: data?.error || 'Ошибка регистрации',
      };
    }
  };

  const logout = async () => {
    try {
      await axios.post(`${API_BASE}/auth/logout`);
    } catch (err) {
      console.error('Logout error:', err);
    }
    setUser(null);
  };

  const value = {
    user,
    login,
    register,
    logout,
    loading,
    isAuthenticated: !!user,
    userId: user?.id
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};